import { render } from "./App.vue?vue&type=template&id=47ddedd6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"pages/EndataAuth/Account/App/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47ddedd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47ddedd6', __exports__)) {
    api.reload('47ddedd6', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=47ddedd6", () => {
    api.rerender('47ddedd6', render)
  })

}


export default __exports__